import { useMemo } from "react";

export interface ReadonlyTableRowSetting<T extends {}> {
	label: string;
	accessor: (data: T) => any;
	isVisible?: (data: T) => boolean;
	placeholder?: string;
	subLabel?: (data: any) => any;
	subAccessor?: (data: any) => any;
	isArray?: boolean;
}

export const ReadonlyValueTableRow = function <T extends {}>({
	rowSetting: {
		placeholder = "N/A",
		accessor,
		isVisible,
		label,
		isArray = false,
		subLabel,
		subAccessor,
	},
	data,
}: {
	rowSetting: ReadonlyTableRowSetting<T>;
	data: T;
}) {
	if (isVisible) {
		if (!isVisible(data)) return null;
	}

	if (isArray) {
		const dataArray = accessor(data);
		const rows = [];
		for (const datum of dataArray) {
			rows.push(
				<tr>
					<td>{subLabel(datum)}</td>
					<td>{subAccessor(datum)}</td>
				</tr>
			);
		}

		return rows;
	}

	return (
		<tr>
			<td>
				<strong>{label}:</strong>
			</td>
			<td>{accessor(data) || placeholder}</td>
		</tr>
	);
};

export const ReadonlyValueTable = function <T extends {}>({
	settings,
	data,
	className,
}: {
	settings: ReadonlyTableRowSetting<T>[];
	data: T;
	className?: string;
}) {
	const rows = useMemo(
		() =>
			settings.map((s, i) => (
				<ReadonlyValueTableRow key={i} rowSetting={s} data={data} />
			)),
		[data, settings]
	);

	return (
		<table className={`paddingBetweenCols ${className}`}>
			<tbody>{rows}</tbody>
		</table>
	);
};
